module.exports = __webpack_public_path__ + "img/platform-5.164c6dc8.png";